import React from "react";
import { Button, Radio, Space, Typography } from "antd";

const { Paragraph } = Typography;

export default function StepPrescription({ value, onPick, onBack }) {
  return (
    <Space direction="vertical" size={14} style={{ width: "100%" }}>
      <Paragraph className="bv-subtext">
        Para efetuar a compra das lentes é necessário a receita!
      </Paragraph>

      <Radio.Group
        value={value}
        onChange={(e) => onPick(e.target.value)}
        style={{ width: "100%" }}
      >
        <Space direction="vertical" size={12} style={{ width: "100%" }}>
          <Radio className="bv-radio" value="sim">
            Sim, tenho a receita em mãos
          </Radio>
          <Radio className="bv-radio" value="nao">
            Não tenho receita
          </Radio>
        </Space>
      </Radio.Group>

      <Button size="large" className="bv-secondary" onClick={onBack}>
        Voltar
      </Button>
    </Space>
  );
}